import { style } from '@vanilla-extract/css';
import { themeVars } from '@tundr/theme';

export const authContentWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  width: 475,
});

export const authHeaderWrapperClass = style({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: themeVars.space.x4,
  marginBottom: themeVars.space.x8,
  textAlign: 'center',
});

export const headerTitleClass = style({
  margin: 0,
  whiteSpace: 'break-spaces',
});

export const headerSubitleClass = style({
  fontSize: themeVars.font.size.textLg,
  marginRight: themeVars.space.x2,
});

export const authContentClass = style({
  display: 'flex',
  flexDirection: 'column',
});
